import { gql } from '@apollo/client';

const DELETE_HELP_ARTICLE = gql`mutation deleteHelpArticle($articleId: Int!) {
  helpContext {
    deleteHelpArticle(articleId: $articleId) {
			success
			message
      articleId: id
    }
  }
}`;

export default DELETE_HELP_ARTICLE;
